// Copyright (c) Docugami, Inc. All rights reserved.

/**
 * Error thrown when a specific network request has been disabled. This typically occurs
 * if the same request is made too frequently within a given time window.
 */
export class RequestDisabledError extends Error {
    private readonly _url: string;
    private readonly _baseUrl: string;
    private readonly _track: boolean;

    public get url(): string { return this._url; }
    public get baseUrl(): string { return this._baseUrl }
    public get track(): boolean { return this._track; }

    constructor(url: string, baseUrl: string, track: boolean, message?: string) {
        super(message);

        Object.setPrototypeOf(this, new.target.prototype);
        this.name = RequestDisabledError.name;
        this._url = url;
        this._baseUrl = baseUrl;
        this._track = track;
    }
}
